<div id="maindiv" class="print-container">
  <div *ngIf="reservation && reservation.ID">

    <div class="partner-logo">
      <img [src]="reservation.ImageFilename" />
    </div>

    <div class="jobcard-number">
      #{{ reservation.ReservationNumber }}
    </div>
    <div class="barcode-container">
      <div *ngIf="reservation.ShowBarCodeOnPrint">
        <ngx-barcode6 [bc-value]="reservation.ReservationNumber" [bc-display-value]="false" [bc-height]="50"
          [bc-width]="3" [bc-format]="'CODE128'"></ngx-barcode6>
      </div>
      <div *ngIf="qrCodeURL && reservation.ShowQRCodeOnPrint">
        <qrcode [width]="120" [qrdata]="qrCodeURL" colordark="rgba(30, 30, 30, 1)" usesvg="true"></qrcode>
      </div>
    </div>

    <div class="block">
      <div class="partner-title">{{ reservation.Name }}</div>
      <div class="jobcard-status">{{ reservation.Status }}</div>
      <div class="block-title">
        {{ 'bikeshop.print.customer_details' | translate }}:
      </div>
      <div class="block-content">
        <div>
          {{ reservation.Customer }}
        </div>
        <div *ngIf="reservation.Email">
          {{ reservation.Email }}
        </div>
        <div *ngIf="reservation.PhoneNumber">
          {{ reservation.PhoneNumber }}
        </div>
      </div>
    </div>


    <div class="block">
      <div class="block-title">
        {{ 'bikeshop.rentals.booking.from_date' | translate }}:
      </div>
      <div class="block-content">
        <span class="fa fa-clock-o"></span> {{ reservation.FromDate | DateFormatPipe: displayDateTimeFormat }} - <span
          class="fa fa-clock-o"></span> {{ reservation.ToDate | DateFormatPipe: displayDateTimeFormat }}
      </div>
    </div>

    <div class="block">
      <div class="block-title">
        {{ 'bikeshop.rentals.products.products' | translate }}:
      </div>
      <div class="block-content">
        <div *ngFor="let rentedProduct of reservation.RentedProducts">
          <div>{{rentedProduct.Brand}} {{rentedProduct.Model}}<span *ngIf="rentedProduct.Color">
              {{rentedProduct.Color}}</span> <span *ngIf="rentedProduct.Size"> {{rentedProduct.Size}}</span> <span
              *ngIf="rentedProduct.SerialNumber"> {{rentedProduct.SerialNumber}}</span><span
              *ngIf="rentedProduct.WaiverSigned" class="bold"> - {{ 'bikeshop.rentals.summary.waiver_signed' | translate
              }}</span></div>
          <ul>
            <li *ngFor="let rentedAccessory of rentedProduct.RentedAccessories" style="list-style-type: disc;">
              {{rentedAccessory.Brand}} {{rentedAccessory.Name}}<span *ngIf="rentedAccessory.Size">
                {{rentedAccessory.Size}}</span><span *ngIf="rentedAccessory.SerialNumber">
                {{rentedAccessory.SerialNumber}}</span></li>
          </ul>
          <ul *ngIf="rentedProduct.CustomQuestionResponses" class="margin-top-8">
            <li *ngFor="let questionResponse of rentedProduct.CustomQuestionResponses" style="list-style-type: circle;">
              {{questionResponse.Question}}: {{questionResponse.Response}}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="block" *ngIf="reservation.ClientNotes">
      <div class="block-title">
        {{ 'bikeshop.modal.update_job_card.job_card.customer_notes' | translate }}:
      </div>
      <div class="block-content">
        {{reservation.ClientNotes}}
      </div>
    </div>

    <div class="block" *ngIf="reservation.StoreNotes">
      <div class="block-title">
        {{ 'bikeshop.rentals.booking.store_notes' | translate }}:
      </div>
      <div class="block-content">
        {{reservation.StoreNotes}}
      </div>
    </div>

    <div class="quote-footer">
      <div *ngIf="reservation.InvoiceLineItems != null && reservation.InvoiceLineItems.length > 0">
        <div class="quote-row border-bottom">
          <div class="flex-8 bold">{{ 'bikeshop.print.item' | translate }}</div>
          <div class="flex-1 right bold">#</div>
          <div class="flex-3 right bold">{{ 'bikeshop.print.price' | translate }}</div>
        </div>
        <div class="quote-row" *ngFor="let lineItem of reservation.InvoiceLineItems">
          <div class="flex-8">
            {{ lineItem.Name }}
            <div *ngIf="lineItem.LineItemNote" style="font-size: 90%;margin-top: -2px;font-style: italic;">
              *{{lineItem.LineItemNote}}</div>
          </div>
          <div class="flex-1 right">{{ lineItem.Quantity }}</div>
          <div class="flex-3 right">{{reservation.CurrencySymbol}}{{ (reservation.VATInclusive ?
            lineItem.UnitPrice_IncludingTax.toFixed(2) : lineItem.UnitPrice.toFixed(2)) | number : '.2-2' }}</div>
        </div>
        <div class="quote-row border-top">
          <div class="flex-9 right bold">{{ 'bikeshop.modal.update_job_card.quote.sub-total' | translate }}:</div>
          <div class="flex-3 right bold">{{reservation.CurrencySymbol}}{{ reservation.SubTotal | number : '.2-2' }}
          </div>
        </div>
        <div class="quote-row">
          <div class="flex-9 right bold">{{ 'bikeshop.modal.update_job_card.quote.discount' | translate }}:</div>
          <div class="flex-3 right bold">{{reservation.CurrencySymbol}}{{ reservation.Discount | number : '.2-2' }}
          </div>
        </div>
        <div class="quote-row" *ngIf="helpersService.showTaxRow(reservation.Tax)">
          <div class="flex-9 right bold">{{ 'bikeshop.print.tax' | translate }}:</div>
          <div class="flex-3 right bold">{{reservation.CurrencySymbol}}{{ reservation.Tax | number : '.2-2' }}</div>
        </div>
        <div class="quote-row">
          <div class="flex-9 right bold">{{ 'bikeshop.print.total' | translate }}:</div>
          <div class="flex-3 right bold">{{reservation.CurrencySymbol}}{{ reservation.Total | number : '.2-2' }}</div>
        </div>
      </div>
    </div>


  </div>
</div>